import { render, staticRenderFns } from "./SQuesForty.vue?vue&type=template&id=1d60910e&scoped=true&"
import script from "./SQuesForty.vue?vue&type=script&lang=js&"
export * from "./SQuesForty.vue?vue&type=script&lang=js&"
import style0 from "./SQuesForty.vue?vue&type=style&index=0&id=1d60910e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d60910e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCardText})
